export default __webpack_public_path__ + "static/media/714.7e5c7fbb.png";